// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteMessageDialog_deleteButton__jJCpw","dialog":"DeleteMessageDialog_dialog__Tw8gZ","dialogButton":"DeleteMessageDialog_dialogButton__NaA-T"};